import React, { useState, useRef, useEffect, useCallback } from 'react'
import t from '~t'
import { useDispatch, useSelector } from 'react-redux'
import { userStatus, errorReason } from '~data/selectors/user'
import { lostPassword } from '~data/actions/user'

import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { Button, Layout, Label, Text, ButtonRow, Preloader, HeaderTitle as Title, Header } from '~ui'
import { Error } from '~co/overlay/dialog'

export default function AccountLost() {
    const dispatch = useDispatch()
    const status = useSelector(state => userStatus(state).lost)
    const error = useSelector(state => errorReason(state).lost)

    const [email, setEmail] = useState('')

    const prevError = useRef(error)
    useEffect(() => {
        if (prevError.current != error)
            Error(error)
        prevError.current = error
    }, [error])

    const onChangeValue = useCallback(e => setEmail(e.target.value), [])

    const onSubmit = useCallback(
        e => {
            e.preventDefault()
            dispatch(lostPassword({ email }))
        },
        [dispatch, email]
    )

    if (status == 'success')
        return (
            <Layout>
                <Header data-fancy>
                    <Title>{t.s('passwordResetEmailSent')}</Title>
                </Header>

                <Button
                    as={Link}
                    variant='outline'
                    data-block
                    to='/account/login'>
                    {t.s('signIn')}
                </Button>
            </Layout>
        )

    return (
        <form onSubmit={onSubmit}>
            <Helmet><title>{t.s('recoverPassword')}</title></Helmet>
            <Header data-fancy>
                <Title>{t.s('recoverPassword')}</Title>
            </Header>

            <Layout>
                <Label>{t.s('email')}</Label>
                <Text
                    type='email'
                    inputMode='email'
                    autoCapitalize='none'
                    spellCheck='false'
                    name='email'
                    disabled={status == 'loading'}
                    autoFocus
                    required
                    value={email}
                    onChange={onChangeValue} />

                <ButtonRow>
                    {status == 'loading' ? (
                        <Button variant='flat'>
                            <Preloader />
                        </Button>
                    ) : (
                        <Button
                            as='input'
                            type='submit'
                            variant='primary'
                            value={t.s('recoverPassword')} />
                    )}

                    <Button
                        as={Link}
                        variant='outline'
                        to='/account/login'>
                        {t.s('cancel')}
                    </Button>
                </ButtonRow>
            </Layout>
        </form>
    )
}
